<template>
    <v-container fluid class="businesses">
        <v-row>
            <v-col>
                <v-expansion-panels v-model="filteringOptionsPanel">
                    <v-expansion-panel>
                        <v-expansion-panel-header><h2 class="title">Search Businesses</h2></v-expansion-panel-header>
                        <v-expansion-panel-content style="border-top: 0.5px solid #ddd;">
                            <v-row>
                                <v-col cols="12" xs="12" sm="6" md="4">
                                    <v-text-field v-model="filters.id" label="Business Id" prepend-icon="format_list_numbered" persistent-hint class="text-field"></v-text-field>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="4">
                                    <v-text-field v-model="filters.name" label="Business Name" persistent-hint prepend-icon="person" class="text-field"></v-text-field>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="4">
                                    <v-text-field
                                        v-model="filters.phone"
                                        label="Business Phone"
                                        persistent-hint
                                        mask="phoneMask"
                                        prepend-icon="phone"
                                        clearable
                                        :rules="[rules.phone]"
                                        class="text-field"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="justify-end">
                                <v-col cols="12" xs="12" sm="6" md="4">
                                    <v-menu v-model="fromDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="formattedFromDate"
                                                label="Updated at Date (From)"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                v-bind="attrs"
                                                v-on="on"
                                                @click:clear="filters.updated_at_from = null"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="filters.updated_at_from" @input="fromDate = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-menu v-model="toDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="formattedToDate"
                                                label="Updated at Date (To)"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                v-bind="attrs"
                                                v-on="on"
                                                @click:clear="filters.updated_at_to = null"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="filters.updated_at_to" @input="toDate = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row class="align-center justify-end text-center">
                                <v-col cols="12" xs="12" sm="6" md="1">
                                    <v-select v-model="filters.limit" :items="limitOptions" label="Limit" persistent-hint></v-select>
                                </v-col>
                                <div class="d-flex justify-md-right justify-center px-3" :class="{ 'w-100': $vuetify.breakpoint.smAndDown }">
                                    <v-btn color="secondary" @click="loadData()"><v-icon left>search</v-icon> Search</v-btn>
                                </div>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-card class="content-card my-4">
                    <v-card-title>
                        <v-text-field
                            @click.native.stop
                            v-model="search"
                            placeholder="Search"
                            prepend-inner-icon="search"
                            single-line
                            hide-details
                            style="width: 15px;"
                            color="primary"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" class="white--text" @click="$router.push({ name: 'businesses.create' })"> <v-icon class="button-icon">add</v-icon>Create </v-btn>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="getBusinesses" :items-per-page="-1" :search="search" class="elevation-1">
                        <template v-slot:item="props">
                            <tr class="business-row" @click="goToBusiness(props.item)">
                                <td class="text-xs-center">
                                    {{ props.item.id }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.name }}
                                </td>
                                <td>
                                    <strong>{{ props.item.phone || ' - ' }}</strong>
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.city }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.email || ' - ' }}
                                </td>
                                <td class="text-xs-center">
                                    {{ props.item.website || ' - ' }}
                                </td>
                                <td class="text-xs-center">
                                    {{ props.item.facebook_url || ' - ' }}
                                </td>
                                <td class="text-xs-center">
                                    {{ props.item.instagram_url || ' - ' }}
                                </td>
                                <td class="text-center px-0">
                                    <v-icon
                                        small
                                        class="px-1"
                                        @click="
                                            $router.push({
                                                name: 'businesses.edit',
                                                params: { id: props.item.id },
                                            });
                                            $event.stopImmediatePropagation();
                                        "
                                        >edit</v-icon
                                    >
                                    <v-icon
                                        small
                                        class="px-1"
                                        @click="
                                            showDuplicateBusinessDialog(props.item.id);
                                            $event.stopImmediatePropagation();
                                        "
                                        >file_copy</v-icon
                                    >
                                    <v-icon
                                        disabled
                                        small
                                        class="px-1"
                                        @click.stop="
                                            openDeleteDialog(props.item);
                                            $event.stopImmediatePropagation();
                                        "
                                        >delete</v-icon
                                    >
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="duplicateBusinessDialog" width="300" persistent="">
            <v-card>
                <v-card-title>
                    Είσαι σίγουρος;
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="gray"
                        text
                        @click="
                            duplicateBusinessDialog = false;
                            duplicateBusinessId = null;
                        "
                        >ΑΚΥΡΟ</v-btn
                    >
                    <v-btn color="primary" text @click="duplicateBusiness()">ΝΑΙ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';
import moment from 'moment';
import { mask } from 'vue-the-mask';

import { BusinessesApi } from '@/api';

export default {
    name: 'Businesses',
    directives: {
        mask,
    },
    data: () => ({
        duplicateBusinessDialog: false,
        duplicateBusinessId: null,
        filteringOptionsPanel: 0,
        search: '',
        filters: {
            id: null,
            name: null,
            phone: null,
            limit: 100,
            updated_at_from: null,
            updated_at_to: null,
        },
        fromDate: false,
        toDate: false,
        limitOptions: [100, 250, 500, 1000],
        headers: [
            {
                text: 'Id',
                align: 'left',
                sortable: true,
                value: 'id',
                width: '7%',
            },
            {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'name',
                width: '15%',
            },
            {
                text: 'Phone',
                align: 'left',
                sortable: false,
                value: 'phone',
                width: '10%',
            },
            {
                text: 'City',
                align: 'left',
                sortable: false,
                value: 'city',
                width: '10%',
            },
            {
                text: 'Email',
                align: 'left',
                sortable: true,
                value: 'email',
                width: '12%',
            },
            {
                text: 'Website',
                align: 'left',
                sortable: true,
                value: 'website',
                width: '12%',
            },
            {
                text: 'Facebook',
                align: 'left',
                sortable: true,
                value: 'facebook_url',
                width: '12%',
            },
            {
                text: 'Instagram',
                align: 'left',
                sortable: true,
                value: 'instagram_url',
                width: '12%',
            },
            {
                text: 'Actions',
                value: '',
                align: 'center',
                sortable: false,
                width: '10%',
            },
        ],
        deleteDialog: false,
        itemToDelete: null,
        phoneMask: '(XXX) XXX - XXXX',
        rules: {
            name: value => (value && value.length >= 3 && value.length <= 20) || 'Field must be between 3 and 20 characters',
            phone: value => (value && value.length === 10) || !value || 'Phone must have 10 characters',
        },
    }),
    computed: {
        ...mapGetters('Businesses', {
            getBusinesses: 'getBusinesses',
        }),
        formattedFromDate() {
            return this.filters.updated_at_from ? moment(this.filters.updated_at_from).format('DD-MM-YYYY') : '';
        },
        formattedToDate() {
            return this.filters.updated_at_to ? moment(this.filters.updated_at_to).format('DD-MM-YYYY') : '';
        },
    },
    created() {
        if (this.getBusinesses.length > 0) {
            this.filteringOptionsPanel = 1;
        }
    },
    methods: {
        ...mapMutations('Businesses', {
            loadBussinessesMutation: 'loadBussinessesMutation',
            duplicateBussinessMutation: 'duplicateBussinessMutation',
        }),
        async loadData() {
            const { data: items } = await BusinessesApi.all(this.filters);
            this.loadBussinessesMutation(items);
            this.filteringOptionsPanel = 1;
        },
        goToBusiness(item) {
            this.$router.push({
                name: 'businesses.details',
                params: { id: item.id },
            });
        },
        showDuplicateBusinessDialog(businessId) {
            this.duplicateBusinessId = businessId;
            this.duplicateBusinessDialog = true;
        },
        async duplicateBusiness() {
            try {
                const { data } = await BusinessesApi.duplicate(this.duplicateBusinessId);
                this.duplicateBusinessDialog = false;
                this.duplicateBussinessMutation(data);
                this.duplicateBusinessId = null;
                this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η κλωνοποίηση της επιχείρησης ολοκληρώθηκε επιτυχώς!', color: 'success' });
            } catch (error) {
                this.duplicateBusinessDialog = false;
                this.duplicateBusinessId = null;
                this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η κλωνοποίηση της επιχείρησης απέτυχε!', color: 'error' });
            }
        },
        // openDeleteDialog(item) {
        //     this.itemToDelete = item;
        //     this.deleteDialog = true;
        // },
        // deleteItem() {
        //     Giveaways.delete(this.itemToDelete.id)
        //         .then(() => {
        //             this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Giveaway deleted', color: 'success' });
        //             this.itemToDelete = null;
        //             Giveaways.all()
        //                 .then((response) => {
        //                     this.giveaways = response.data;
        //                 }).catch((error) => {
        //                     this.$store.commit(SET_SNACKBAR_STATUS, { message: error.response.data, color: 'error' });
        //                 });
        //             this.closeDeleteDialog();
        //         }).catch((error) => {
        //             this.$store.commit(SET_SNACKBAR_STATUS, { message: error.response.data, color: 'error' });
        //         });
        // },
        // closeDeleteDialog() {
        //     this.deleteDialog = false;
        // },
    },
};
</script>

<style lang="scss">
.businesses {
    .action-card {
        padding: 1rem;

        .v-text-field {
            padding-top: 0;
            margin-top: 8px;
        }

        .v-input__slot {
            margin-bottom: 0;
        }

        .button-icon {
            margin-right: 5px;
        }
    }

    .content-card {
        .business-row {
            cursor: pointer;
        }
    }
}
</style>
